import { PPHIOrderFailed, PPHIOrderInProgress, PPHIOrderSuccess } from "../../../assets/img/svg";
import paymodeMapper from "../service/paymodeMapper.json";
import "./pphi.scss"; // Assuming you have a CSS file for styling
const moment = require("moment");

const PPHIResult = ({ orderData, ppphiData, handlePPHIRetry }) => {
    return (
        <div className="payment-success-pphi space-y-4 row">
            <div className="payment-success-pphi-header text-center col-md-6">
                <h4 className="text-xl font-bold">
                    {orderData?.order_data?.order_data?.status === "SUCCESS"
                        ? "Payment Successful!"
                        : orderData?.order_data?.order_data?.status === "FAILED"
                            ? "Payment Failed!"
                            : "Payment In Progress"}
                </h4>
                <div className="success-icon my-2">
                    {orderData?.order_data?.order_data?.status === "SUCCESS" ? (
                        <PPHIOrderSuccess />
                    ) : orderData?.order_data?.order_data?.status === "FAILED" ? (
                        <PPHIOrderFailed />
                    ) : (
                        <PPHIOrderInProgress />
                    )}
                </div>
                <p style={{ color: "gray" }}>
                    {orderData?.order_data?.order_data?.status === "SUCCESS"
                        ? `Your payment against application is Successful.`
                        : orderData?.order_data?.order_data?.status === "FAILED" ?
                            "Your Payment could not be completed."
                            : "Your Payment is still in progress. Please wait."}
                </p>
            </div>
            <div className="payment-methods-pphi space-y-2 col-md-6 ms-md-4">
                {orderData?.order_data?.order_data
                    ?.pl_order_id && (
                        <div className="payment-method-row flex justify-around">
                            <p>Order ID</p>
                            <span className="money-pphi">
                                {
                                    orderData?.order_data?.order_data
                                        ?.pl_order_id
                                }
                            </span>
                        </div>
                    )}
                {orderData.order_data?.order_data?.created_date && (
                    <div className="payment-method-row flex justify-around">
                        <p>Created Date</p>
                        <span className="money-pphi">
                            {
                                moment(orderData?.order_data?.order_data?.created_date).local().format("DD/MM/YYYY HH:mm:ss")
                            }
                        </span>
                    </div>)}
                {orderData?.order_data?.attempt_data?.status && (
                    <div className="payment-method-row flex justify-around">
                        <p>Status</p>
                        <span className="money-pphi">
                            {orderData?.order_data?.attempt_data?.status}
                        </span>
                    </div>
                )}
                {orderData?.order_data?.order_data?.status !== "SUCCESS" && (
                    <div className="payment-method-row flex justify-around">
                        <p>Error Message</p>
                        <span className="money-pphi">
                            {orderData?.order_data?.attempt_data
                                ?.pa_bank_error_message || "-"}
                        </span>
                    </div>
                )}
                <div className="payment-method-row flex justify-around">
                    <p>
                        <span>
                            {orderData?.order_data?.attempt_data
                                ?.status === "SUCCESS"
                                ? "🟢"
                                : "🔴"}{" "}
                        </span>
                        {orderData?.order_data?.attempt_data
                            ?.pa_payment_method_type === "CARD"
                            ? paymodeMapper[
                            `${orderData?.order_data?.attempt_data?.pa_card_type?.toUpperCase()}`
                            ]
                            : paymodeMapper[
                            `${orderData?.order_data?.attempt_data?.pa_payment_method_type?.toUpperCase()}`
                            ]}


                    </p>
                    <span className="money-pphi">
                        ₹{" "}
                        {
                            orderData?.order_data?.attempt_data
                                ?.pa_txn_amount
                        }
                    </span>
                </div>

                {/* Convenience Fee - Only show if surcharge amount > 0 */}
                {orderData?.order_data?.attempt_data?.pa_surcharge_amount > 0 && (
                    <>
                        <hr className="m-0 p-0" />
                        <div className="payment-method-row flex justify-around">
                            <p>Convenience Fee</p>
                            <span className="money-pphi">
                                ₹{" "}
                                {orderData?.order_data?.attempt_data?.pa_surcharge_amount}
                            </span>
                        </div>
                    </>
                )}

                <hr className="m-0 p-0" />
                <p className="mb-0">Previous Payments</p>
                {ppphiData?.payment_history?.map((ele, index) => (
                    <div
                        key={index}
                        className="payment-method-row flex justify-around"
                    >
                        <p>
                            <span>🟢</span> {ele.mode}
                        </p>
                        <span className="money-pphi">
                            ₹ {ele.amount}
                        </span>
                    </div>
                ))}
                {
                    orderData?.order_data?.attempt_data
                        ?.status !== "SUCCESS" && (
                        <button
                            className="bg-pink-500 text-black px-4 py-2 rounded border hover:bg-pink-900 pphi-button"
                            onClick={() => handlePPHIRetry()}
                        >
                            {orderData?.order_data?.attempt_data?.status == "FAILED" ? "Retry" : "Check Status"}
                        </button>
                    )
                }
            </div>
        </div>
    );
};

export default PPHIResult;
